<template>
    <div class="jiancha">
        <el-select
                :value="value"
                :class="getClass"
                placeholder="请选择"
                @input="change($event)"
        >
            <el-option
                    v-for="item in options"
                    :class="item.class"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
        </el-select>
    </div>
</template>

<script>
    export default {
        props: ["value","keys","disabled"],
        data() {
            return {
                options: [
                    {
                        class: "yangxing",
                        label: "阳性",
                        value: "阳性"
                    },
                    {
                        class: "biaoda",
                        label: "部分表达",
                        value: "部分表达"
                    },
                    {
                        class: "yinxing",
                        label: "阴性",
                        value: "阴性"
                    },
                    {
                        class: "weixiang",
                        label: "未做",
                        value: "未做"
                    }
                ]
            };
        },
        computed: {
            getClass() {
                var flag = ''
                if (this.$store.state.registration.form9.indexOf('form5_' + this.keys) >= 0) {
                    flag = " container";
                }
                if (this.value == "阳性") return "select_yangxing " + flag;
                else if (this.value == "阴性") return "select_yinxing " + flag;
                else if (this.value == "未做") return "select_weixiang " + flag;
                else if (this.value == "部分表达") return "select_biaoda " + flag;
                else return "select_weixuan " + flag;
            }
        },
        methods: {
            change: function (val) {
                this.$emit("input", val);
                this.$emit("checkPoints", val)
            },
        },
    };
</script>

<style scoped>
    .jiancha .el-select {
        /*width: 78px;*/
        color: white;
    }

    /*.jiancha /deep/ .el-select .el-input .el-select__caret {*/
    /*    !*color: #fff;*!*/
    /*    height: 25px;*/
    /*    line-height: 25px;*/
    /*}*/

    .jiancha /deep/ .el-input__inner {
        border: none;
        /* padding: 0 5px; */
        /*padding-left: 15px;*/
        /*padding-right: 25px;*/
        height: 20px;
        line-height: 20px;
        /*color: white;*/
    }

    .jiancha /deep/ .el-input__inner::-webkit-input-placeholder {
        /* placeholder颜色  */
        /*color: #fff;*/
        /* placeholder字体大小  */
        font-size: 12px;
        /* placeholder位置  */
        /*text-align: right;*/
    }

    .yangxing {
        background-color: #f88;
        color: white;
    }

    .select_yangxing {
        background-color: #f88;
        color: white;
        border-radius: 3px;
    }

    .yinxing {
        background-color: #528a36;
        color: white;
    }

    .select_yinxing {
        background-color: #67c23a;
        border-radius: 3px;
    }

    .biaoda {
        background-color: sandybrown;
        color: white;
    }

    .select_biaoda {
        background-color: sandybrown;
        border-radius: 3px;
    }

    .weixiang {
        background-color: #999;
        color: white;
    }

    .select_weixiang {
        background-color: #909399;
        color: white;
        border-radius: 3px;
    }

    .weixuan {
        background-color: #f7f7f8;
        color: white;
    }

    .select_weixuan {
        background-color: #f7f7f8;
        color: white;
        border-radius: 3px;
    }

    .select_weixuan {
        background-color: #f7f7f8;
        color: #333 !important;
        border-radius: 3px;
    }

    .select_weixuan /deep/ .el-select__caret {
        color: #333 !important;
    }

    /deep/ input::-webkit-outer-spin-button,
    /deep/ input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        margin: 0;
    }

    /deep/ input[type="number"] {
        -moz-appearance: textfield;
    }

    .rows /deep/ .el-input-group__append {
        padding: 0 5px;
        background-color: #fff;
        font-size: 10px;
        border-left: 0;
    }

    .row /deep/ .el-input-group__append,
    .row /deep/ .el-input-group__prepend {
        padding: 0 5px;
        background-color: #fff;
        font-size: 10px;
    }

    /deep/ .el-form-item__label {
        font-size: 13px;
    }

    .el-col-4 {
        font-size: 14px;
    }

    .row /deep/ .el-input__inner {
        padding: 0 5px;
    }

    .row {
        margin: 20px 0;
        border-bottom: 1px solid #eee;
    }

    /deep/ .el-select .el-input {
        width: 80px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    /deep/ .el-input-group__append .el-button, .el-input-group__append .el-select, .el-input-group__prepend .el-button, .el-input-group__prepend .el-select {
        display: inline-block;
        margin: -2px 10px;
        font-size: small;
    }

    /deep/ .el-input__suffix {
        color: white;
        left: 58px;
        display: flex;
        align-items: center;
        -webkit-transition: all .3s;
        transition: all .3s;
    }
    .container /deep/ .el-input {
        border: 1px solid red;
    }
</style>
